import React, { createContext, useReducer, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { campusByID } from '../constants/campuses';
import { wayfindingByID } from '../constants/wayfinding';
import appReducer from './AppReducer';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, null);

  const [searchParams] = useSearchParams();
  useEffect(() => {
    let initialState = {
      campus: 'ndc', // probably not necessary
      center: { lat: 49.92, lng: -97.21122 },
      zoom: 17,
      selectedMarkers: [],
    };
    if (searchParams.has('campus')) {
      const { id, lat, lng } = campusByID(searchParams.get('campus'));
      initialState.campus = id;
      initialState.center = { lat, lng };
      initialState.zoom = id === 'swc' ? 13 : 17; // Set default zoom to 13 for SWC campus
    }
    if (searchParams.has('markers')) {
      const markerString = searchParams.get('markers');
      if (markerString) {
        initialState.selectedMarkers = markerString.split(',');
      }
    }
    if (searchParams.has('wayfinding')) {
      const wayfindingID = searchParams.get('wayfinding');
      if (wayfindingID) {
        initialState.wayfinding = wayfindingByID(wayfindingID);
        initialState.center = {
          lat: initialState.wayfinding.lat,
          lng: initialState.wayfinding.lng,
        };
      }
    }
    dispatch({
      type: 'INITIALIZE_REDUCER',
      payload: initialState,
    });
  }, []);

  function openMarkersDialog() {
    dispatch({
      type: 'OPEN_MARKERS_DIALOG',
      payload: true,
    });
  }

  function closeMarkersDialog() {
    dispatch({
      type: 'CLOSE_MARKERS_DIALOG',
      payload: false,
    });
  }

  function setMapCenter(center) {
    dispatch({
      type: 'SET_MAP_CENTER',
      payload: center,
    });
  }

  function updateMap({ center, zoom }) {
    dispatch({
      type: 'UPDATE_MAP',
      payload: { center, zoom },
    });
  }

  function setCampus(campusId) {
    dispatch({
      type: 'SET_CAMPUS',
      payload: campusId,
    });
  }

  function toggleMarker(id) {
    dispatch({
      type: 'TOGGLE_MARKER',
      payload: id,
    });
  }

  if (!state) return null;

  return (
    <GlobalContext.Provider
      value={{
        store: state,
        setMapCenter,
        updateMap,
        setCampus,
        openMarkersDialog,
        closeMarkersDialog,
        toggleMarker,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
